import React, { useState } from 'react';
import Sidebar from './Sidebar';

// CẬP NHẬT: Nhận thêm connectingDeviceId
const LinkDevice = ({ isVisible, onBack, onContinue, onLogout, connectingDeviceId }) => {
  const [deviceName, setDeviceName] = useState('Smart Lamp');
  const [selectedRoom, setSelectedRoom] = useState('Living room');

  if (!isVisible) return null;

  const rooms = ['Living room', 'Kitchen', 'Bedroom', 'Bathroom'];

  return (
    <div className="dashboard-container">
      <Sidebar activeId="devices" onLogout={onLogout} />

      <div className="main-content setup-layout">
        {/* --- HEADER --- */}
        {/* ... (Header giữ nguyên) ... */}
        <div className="setup-header">
          <button className="back-btn" onClick={onBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          </button>
          
          <div className="header-titles">
            <h2>Link new device</h2>
            <p>Connect with your space</p>
          </div>
          
          <div style={{width: '40px'}}></div> 
        </div>

        {/* --- BODY --- */}
        {/* ... (Body giữ nguyên) ... */}
        <div className="setup-body column-mode">
          <div className="device-showcase">
            <div className="device-glow-circle">
               <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#1a73e8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M8 2h8l4 10H4L8 2z"/>
                  <path d="M12 12v6"/>
                  <path d="M8 22v-2c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2H8z"/>
               </svg>
            </div>
          </div>

          <div className="device-form-section">
            <div className="input-block">
              <label>What is your device name?</label>
              <input 
                type="text" 
                value={deviceName} 
                onChange={(e) => setDeviceName(e.target.value)}
                className="house-input"
                style={{textAlign: 'center'}}
              />
            </div>

            <div className="input-block">
              <label>Where is your device located?</label>
              <div className="chips room-chips">
                {rooms.map((room) => (
                  <button 
                    key={room} 
                    className={`chip-btn ${selectedRoom === room ? 'selected-yellow' : ''}`}
                    onClick={() => setSelectedRoom(room)}
                  >
                    {room}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* --- FOOTER --- */}
        <div className="setup-footer">
          <div className="footer-content">
            <span className="footer-hint">Customize and link your new device</span>
            <div className="footer-actions">
              <button className="secondary-btn" onClick={onBack}>Skip</button>
              {/* CẬP NHẬT: Sự kiện onClick cho nút Continue */}
              <button className="primary-btn continue-btn" onClick={() => onContinue(connectingDeviceId)}>
                Continue
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default LinkDevice;